import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { queryKeys } from '@/shared/constants/query-keys'
import { companiesAdminV2Service } from '../services/companies-admin-v2.service'

/**
 * Empresas activas (`{ id: cmp_, name, default }`) para los selects v2 que las
 * cascadean —el form de agencias, y más adelante sociedades, clientes y
 * negociaciones—. Sólo corre con sesión staff v2; los datos casi no cambian, así
 * que se cachean largo.
 */
export const useCompaniesV2LookupQuery = () => {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken ?? ''
  return useQuery({
    queryKey: queryKeys.companies.lookupV2(),
    queryFn: async () => await companiesAdminV2Service.lookup(accessToken),
    enabled: Boolean(accessToken),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}
